import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    SAVE_GROUP_LAYOUT: null,
  },
  'SaveGroupLayoutWindow',
);
